<div class="body-small">
  {{ formattedAmount }} {{ currency }}
</div>